// FAQ headings in display order — mirrors backend/faq_utils.py FAQ_CATEGORIES.
export const FAQ_CATEGORIES = [
  "Getting started",
  "Adding recipes",
  "Cookbooks & sharing",
  "Cooking tools",
  "Voice",
  "Shopping list",
  "Meal planner",
  "Printing & books",
  "Plans, gifts & billing",
  "Family plan & live sharing",
  "Account, privacy & data",
  "Historical recipes",
  "About Recipe Filer",
];

export const faqCatId = (c) => `faq-${(c || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`;

// Group FAQs by heading, headings in FAQ_CATEGORIES order (unknown headings last).
export function groupFaqs(faqs) {
  const order = (c) => { const i = FAQ_CATEGORIES.indexOf(c); return i < 0 ? 99 : i; };
  const map = new Map();
  for (const f of faqs) {
    const c = f.category || "About Recipe Filer";
    if (!map.has(c)) map.set(c, []);
    map.get(c).push(f);
    for (const extra of f.also_in || []) {
      if (!map.has(extra)) map.set(extra, []);
      map.get(extra).push({ ...f, _also: true });
    }
  }
  return [...map.entries()].sort((a, b) => order(a[0]) - order(b[0]));
}

// Answers use a tiny markdown subset: **bold**. Plain version for meta / JSON-LD.
export const faqPlain = (s) => (s || "").replace(/\*\*/g, "").replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, "$1");
export const faqRich = (s) => (s || "").split(/(\*\*[^*]+\*\*|\[[^\]]+\]\([^)\s]+\))/g).map((part, i) => {
  if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i} className="text-rf-ink">{part.slice(2, -2)}</strong>;
  const m = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
  return m ? <a key={i} href={m[2]} className="text-rf-orange underline font-semibold">{m[1]}</a> : part;
});
